export default {
    error: {
        abort_403_message: "ការចូលដំណើរការត្រូវបានបដិសេធ។ អ្នកប្រហែលជាមិនមានសិទ្ធិសមស្របដើម្បីចូលប្រើទំព័រនេះទេ។",
        abort_403_text: "គ្មានការអនុញ្ញាត",
        abort_404_message: "ទំព័រដែលអ្នកកំពុងស្វែងរកអាចត្រូវបានលុប ឬឈ្មោះរបស់វាត្រូវបានផ្លាស់ប្តូរ។",
        abort_404_text: "រកមិនឃើញទំព័រ",
        required: {
            address_in_cambodia: "សូមបំពេញអាសយដ្ឋាន",
            email: "សូមបំពេញសារអេឡិកត្រូនិក",
            first_name: "សូមបំពេញនាមខ្លួន",
            gender: "សូមជ្រើសរើសភេទ",
            identity_image_back: "សូមជ្រើសរើសរូបអត្តសញ្ញាណប័ណ្ណផ្នែកខាងក្រោយ",
            identity_image_front: "សូមជ្រើសរើសរូបអត្តសញ្ញាណប័ណ្ណផ្នែកខាងមុខ",
            identity_issued_date: "សូមជ្រើសរើសកាលបរិច្ឆេទចេញអត្តសញ្ញាណប័ណ្ណ",
            identity_number: "សូមបំពេញលេខអត្តសញ្ញាណប័ណ្ណ",
            last_name: "សូមបំពេញនាមត្រកូល",
            nationality: "សូមជ្រើសរើសសញ្ជាតិ",
            passport_image_back: "សូមជ្រើសរើសរូបលិខិតឆ្លងដែនផ្នែកខាងមុខ",
            passport_number: "សូមបំពេញលេខលិខិតឆ្លងដែន",
            password: "សូមបំពេញកូដសម្ងាត់"
        },
        saving: "មានបញ្ហាពេលរក្សាទុក",
        something_went_wrong: "មានអ្វីមួយខុសប្រក្រតី",
        vehicle_info_required: "សូមបំពេញព័ត៌មានដែលចាំបាច់របស់យានយន្ត",
    },
    label: {
        about: "អំពីយើង",
        action: "សកម្មភាព",
        add: "បន្ថែម",
        address: "ឤសយដ្ឋាន",
        address_in_cambodia: "ឤសយដ្ឋាននៅកម្ពុជា",
        admin_dashboard: "ប្រព័ន្ធសម្រាប់អ្នកគ្រប់គ្រង",
        agree_to: "ខ្ញុំយល់ស្របនឹង",
        all: "ទាំងអស់",
        already_have_account: "បើមានគណនីរួចហើយសូមចូលប្រើប្រាស់ប្រព័ន្ធ",
        amendment: "ផ្លាស់ប្តូរមាត់ច្រកចូល/ចេញ",
        amendment_date: "ការពន្យារថ្ងៃខែឆ្នាំចូល/ចេញ",
        amendment_office: "ការផ្លាស់ប្តូរមាត់ច្រកចូល/ចេញ",
        amount: "ចំនួន",
        app_dashboard: "ផ្ទាំងគ្រប់គ្រងដើម",
        app_name: "e-Customs",
        application: "ពាក្យស្នើសុំ",
        application_report: "បាយការណ៍ប្រតិវេទន៍",
        applications: "ពាក្យស្នើសុំ",
        approve: "ឯកភាព",
        approve_changed_border_gate: "ឯកភាពនៃការប្តូរមាត់ច្រក",
        approve_extended_date_of_entry: "ឯកភាពនៃការប្តូរថ្ងៃខែឆ្នាំចូល",
        approve_extended_date_of_exit: "ឯកភាពនៃការប្តូរថ្ងៃខែឆ្នាំចេញ",
        asterisk: "ត្រូវតែបញ្ជូល",
        attachment: "ឯកសារភ្ជាប់",
        back: "ត្រឡប់",
        back_side: "ផ្នែកខាងក្រោយ",
        between: "ចន្លោះពី",
        border_pass_date: "កាលបរិច្ឆេទប័ណ្ណព្រំដែន",
        border_pass_number: "លេខប័ណ្ណព្រំដែន",
        brand: "ម៉ាក",
        browse_your_device: "រុករកក្នុងឧបករណ៍របស់អ្នក",
        by_user: "ដោយអ្នកប្រើប្រាស់ឈ្មោះ",
        change_border_gate_of_entry: "ផ្លាស់ប្តូរមាត់ច្រកចូល",
        change_border_gate_of_exit: "ផ្លាស់ប្តូរមាត់ច្រកចេញ",
        change_image: "ផ្លាស់ប្តូររូបភាព",
        changed_at: "បានផ្លាស់ប្តូរនៅថ្ងៃទី",
        choose: "ជ្រើសរើស",
        choose_document: "ជ្រើសរើសឯកសារ",
        choose_driver: "ជ្រើសរើសអ្នកបើកបរ",
        choose_image: "ជ្រើសរើសរូបភាព",
        choose_vehicle: "ជ្រើសរើសយានយន្ត",
        city: "ខេត្ត/រាជធានី",
        close: "បិទ",
        code: "លេខកូដ",
        collapse: "បង្រួម",
        color: "ពណ៌",
        company_address: "អាសយដ្ឋានក្រុមហ៊ុន",
        company_code: "កូដក្រុមហ៊ុន",
        company_information: "ព័ត៌មានក្រុមហ៊ុន",
        company_name: "ឈ្មោះក្រុមហ៊ុន",
        confirm: "បញ្ជាក់",
        confirm_delete: "តើលោកអ្នកពិតជាចង់លុប?",
        confirm_password: "បញ្ជាក់កូដសម្ងាត់",
        contain: "មាន",
        create: "បង្កើត",
        create_application: "បង្កើតពាក្យស្នើសុំ",
        created_at: "កាលបរិច្ឆេទបង្កើត",
        criteria: "លក្ខណៈវិនិច្ឆ័យ",
        currency: "រូបិយប័ណ្ណ",
        customs_registration: "បញ្ជិកាគយ",
        dashboard: "ផ្ទាំងគ្រប់គ្រងដើម",
        date: "កាលបរិច្ឆេទ",
        declaration: "ប្រតិវេទន៍",
        declaration_chart: "ស្ថិតិប្រតិវេទន៍",
        declaration_status: "ការប្រកាសរបស់ខ្ញុំ",
        declaration_status_today: "ការប្រកាសរបស់ខ្ញុំថ្ងៃនេះ",
        declarations: "ប្រតិវេទន៍",
        decline: "មិនឯកភាព",
        decline_changed_border_gate: "មិនឯកភាពនៃការប្តូរមាត់ច្រក",
        decline_extended_date_of_entry: "មិនឯកភាពនៃការប្តូរថ្ងៃខែឆ្នាំចូល",
        decline_extended_date_of_exit: "មិនឯកភាពនៃការប្តូរថ្ងៃខែឆ្នាំចេញ",
        delete: "លុប",
        delete_success: "លុបបានជោគជ័យ",
        deleted_at: "កាលបរិច្ឆេទលុប",
        description: "បរិយាយ",
        destination: "មាត់ច្រកចុងទី",
        destination_assess: "មូលវិចារណ៍មាត់ច្រកចុងទី",
        destination_change: "ការផ្លាស់ប្តូរមាត់ច្រកចេញ",
        destination_office_code: "កូដការិយាល័យចុងទី",
        destination_office_date: "កាលបរិច្ឆេទចុងទី",
        destination_office_name: "ការិយាល័យចុងទី",
        destination_assess_status: "ស្ថានភាពការិយាល័យចុងទី",
        document_size: "ទំហំឯកសារត្រូវតែតិចជាងឬស្មើ 5MB",
        dont_have: "មិនមាន",
        download: "ទាញយក",
        driver: "អ្នកបើកបរ",
        driver_information: "ព័ត៌មានអ្នកបើកបរ",
        drivers: "អ្នកបើកបរ",
        driving_license: "ប័ណ្ណបើកបរ",
        driving_license_image_back: "រូបប័ណ្ណបើកបរផ្នែកខាងក្រោយ",
        driving_license_image_front: "រូបប័ណ្ណបើកបរផ្នែកខាងមុខ",
        driving_license_photo: "រូបថតប័ណ្ណបើកបរ",
        edit: "កែតម្រូវ",
        email: "សារអេឡិកត្រូនិក",
        empty_data: "មិនមានទិន្នន័យនៅឡើយ",
        engine_number: "លេខម៉ាស៊ីន",
        enrouting: "កំពុងមានសកម្មភាព",
        entry: "ចូល",
        entry_date: "កាលបរិច្ឆេទចូល",
        entry_office_code: "កូដការិយាល័យចូល",
        entry_office_name: "ឈ្មោះការិយាល័យចូល",
        entry_vehicles: "យានយន្តចូល",
        entry_vehicles_today: "យានយន្តចូលថ្ងៃនេះ",
        equal: "ស្មើ",
        exit: "ចេញ",
        exit_date: "កាលបរិច្ឆេទចេញ",
        exit_office_code: "កូដការិយាល័យចេញ",
        exit_office_name: "ឈ្មោះការិយាល័យចេញ",
        exit_vehicles: "យានយន្តចេញ",
        exit_vehicles_today: "យានយន្តចេញថ្ងៃនេះ",
        expand: "ពង្រីក",
        expired_date: "ផុតកំណត់",
        extended_date_of_entry: "ពន្យាពេលថ្ងៃខែឆ្នាំចូល",
        extended_date_of_exit: "ពន្យាពេលថ្ងៃខែឆ្នាំចេញ",
        female: "ស្រី",
        file_name: "ឈ្មោះឯកសារ",
        filter: "ច្រោះ",
        first_name: "នាមខ្លួន",
        forgot_password: "ភ្លេចកូដសម្ងាត់?",
        frame_number: "លេខតួ",
        fraud: "កំហុស",
        from: "ពី",
        from_date: "ចាប់ពី",
        front_side: "ផ្នែកខាងមុខ",
        fullname: "គោត្តនាម នាម",
        gender: "ភេទ",
        greater_than: "ធំជាង",
        greater_than_or_equal: "ធំជាងឬស្មើ",
        guarantee_information: "ព័ត៌មានប្រាក់កក់",
        guarantee_information_invalid: "ព័ត៌មានប្រាក់កក់មិនត្រឹមត្រូវទេ",
        have: "មាន",
        having_passport: "តើអ្នកមានលិខិតឆ្លងដែនទេ?",
        home: "ទំព័រដើម",
        i_am_also_a_driver: "តើអ្នកជាអ្នកបើកបរមែនទេ ?",
        i_am_also_driver: "ខ្ញុំក៏ជាអ្នកបើកបរដែរ",
        id: "លេខសំគាល់",
        identity_card: "អត្តសញ្ញាណប័ណ្ណ",
        identity_card_expired_date: "សុពលភាពអត្តសញ្ញណប័ណ្ណ",
        identity_card_photo: "រូបថតអត្តសញ្ញាប័ណ្ណ",
        identity_date: "កាលបរិច្ឆេទអត្តសញ្ញាណប័ណ្ណ",
        identity_image_back: "រូបអត្តសញ្ញាណប័ណ្ណផ្នែកខាងក្រោយ",
        identity_image_front: "រូបអត្តសញ្ញាណប័ណ្ណផ្នែកខាងមុខ",
        identity_number: "លេខអត្តសញ្ញាណប័ណ្ណ",
        image_back: "រូបខាងក្រោយ",
        image_front: "រូបខាងមុខ",
        image_size: "ទំហំរូបភាពត្រូវតែតិចជាងឬស្មើ 2MB",
        input_information_invalid: "ព័ត៌មានបានបញ្ចូលមិនត្រឹមត្រូវទេ!",
        insurance_company_code: "កូដក្រុមហ៊ុនធានារ៉ាប់រង",
        insurance_company_name: "ឈ្មោះក្រុមហ៊ុនធានារ៉ាប់រង",
        insurance_date: "កាលបរិច្ឆេទធានារ៉ាប់រង",
        insurance_number: "លេខធានារ៉ាប់រង",
        is_required: "គឺចាំបាច់",
        issued_date: "កាលបរិច្ឆេទចេញ",
        last_name: "នាមត្រកូល",
        leave_page_subtitle: "អ្នកមានការផ្លាស់ប្តូរមិនបានរក្សាទុក!",
        leave_page_title: "តើអ្នកពិតជាចង់ផ្លាស់ប្តូរទំព័រមែនទេ?",
        length_of_stay: "រយៈពេលស្នាក់នៅ",
        less_than: "តូចជាង",
        less_than_or_equal: "តូចជាងឬស្មើ",
        list: "បញ្ជី",
        loading: "កំពុងដំណើរការ ...",
        lodgement: "មាត់ច្រកដើមទី",
        lodgement_assess: "មូលវិចារមាត់ច្រកដើមទី",
        lodgement_assess_approve: "ឯកភាពដោយការិយាល័យដាក់ឯកសារ",
        lodgement_assess_reject: "បដិសេធដោយការិយាល័យដាក់ឯកសារ",
        lodgement_office_code: "កូដការិយាល័យដើមទី",
        lodgement_office_date: "កាលបរិច្ឆេទដើមទី",
        lodgement_office_name: "ការិយាល័យដើមទី",
        lodgement_assess_status: "ស្ថានភាពការិយាល័យដើមទី",
        login: "ចូលប្រើប្រាស់ប្រព័ន្ធ",
        login_description: "សូមបំពេញសារអេឡិកត្រូនិកនិងកូដសម្ងាត់មុននឹងប្រើប្រាស់ប្រព័ន្ធ",
        login_information: "ព័ត៌មានសម្រាប់ចូលប្រើប្រាស់ប្រព័ន្ធ",
        male: "ប្រុស",
        months: ["មករា","កុម្ភៈ","មីនា","មេសា","ឧសភា","មិថុនា","កក្កដា","សីហា","កញ្ញា","តុលា","វិច្ឆិកា","ធ្នូ"],
        more_info: "មើលបន្ថែម",
        my_profile: "ព័ត៌មានផ្ទាល់ខ្លួន",
        n0: "លរ",
        name: "ឈ្មោះ",
        nationality: "សញ្ជាតិ",
        next: "បន្ទាប់",
        no: "ទេ",
        no_application: "អ្នកពុំទាន់មានប្រតិវេទន៍នៅឡើយ",
        no_data: "មិនមានទិន្នន័យដែលលោកអ្នកស្វែងរកនោះទេ",
        no_image: "គ្មានរូបភាព",
        no_overstay: "គ្មានប្រតិវេទន៍លើសថ្ងៃ",
        no_recently_declaration: "មិនទាន់មានប្រតិវេទន៍",
        not_equal: "មិនស្មើ",
        number: "លេខ",
        office: "ការិយាល័យ",
        office_code: "កូដការិយាល័យ",
        officer: "មន្ត្រី",
        ok: "យល់ព្រម",
        other: "ឯកសារផ្សេងទៀត",
        other_attachment_title: "ឯកសារត្រូវតែទំហំតូចជាង ៥ MB ហើយជាប្រភេទរូបភាពនិង PDF។",
        other_document: "ឯកសារផ្សេងទៀត",
        other_file_criteria: "ប្រភេទឯកសារដែលអនុញ្ញាត: jpeg, png, jpg, pdf & ទំហំ: 10MB",
        other_information: "ព័ត៌មានផ្សេងៗ",
        over_stay_applications: "ប្រតិវេទន៍លើសថ្ងៃ",
        overstay: "ប្រតិវេទន៍លើសថ្ងៃ",
        owner: "ម្ចាស់កម្មសិទ្ធ",
        owner_also_driver: "ម្ចាស់កម្មសិទ្ធក៏ជាអ្នកបើកបរ",
        owner_border_pass: "ប័ណ្ណព្រំដែនម្ចាស់កម្មសិទ្ធ",
        owner_confirm: "តើលោកអ្នកជាម្ចាស់កម្មសិទ្ធ?",
        owner_information: "ព័ត៌មានម្ចាស់កម្មសិទិ្ធ",
        owner_passport: "លិខិតឆ្លងដែន",
        passport: "លិខិតឆ្លងដែន",
        passport_date: "កាលបរិច្ឆេទលិខិតឆ្លងដែន",
        passport_expired_date: "សុពលភាពលិខិតឆ្លងដែន",
        passport_issued_date: "កាលបរិច្ឆេទលិខិតឆ្លងដែន",
        passport_number: "លេខលិខិតឆ្លងដែន",
        passport_photo: "រូបថតលិខិតឆ្លងដែន",
        password: "កូដសម្ងាត់",
        password_confirmation: "ផ្ទៀងផ្ទាត់ពាក្យសម្ងាត់",
        penalize: "ពិន័យ",
        phone: "ទូរស័ព្ទ",
        plate_number: "ផ្លាកលេខ",
        print: "បោះពុម្ព",
        print_all: "ទាំងអស់",
        print_declaration: "ប្រតិវេទន៍",
        print_conveyance_pass: "បណ្ណសម្គាល់",
        profile: "ព័ត៌មានផ្ទាល់ខ្លួន",
        qrcode: "ឃ្យូអាកូដ",
        reason: "មូលហេតុ",
        receipt_number: "លេខបង្កាន់ដៃ",
        recent_declaration: "បញ្ជិកាគយថ្មីៗ",
        register: "ចុះឈ្មោះ",
        register_date: "កាលបរិច្ឆេទចុះបញ្ជី",
        register_new_account: "ចុះឈ្មោះថ្មី",
        register_number: "លេខចុះបញ្ជី",
        register_type: "ប្រភេទស្នើសុំ",
        register_year: "ឆ្នាំចុះបញ្ជី",
        reject: "បដិសេដ",
        reload: "ផ្ទុកឡើងវិញ",
        remove: "លុប",
        report: "របាយការណ៍",
        request_change: "ស្នើរសុំការផ្លាស់ប្តូរ",
        request_change_entry_date: "ស្នើរសុំការផ្លាស់ប្តូរថ្ងៃខែឆ្នាំចូល",
        request_change_entry_office: "ស្នើរសុំការផ្លាស់ប្តូរមាត់ច្រកចូល",
        request_change_exit_date: "ស្នើរសុំការផ្លាស់ប្តូរថ្ងៃខែឆ្នាំចេញ",
        request_change_exit_office: "ស្នើរសុំការផ្លាស់ប្តូរមាត់ច្រកចេញ",
        request_changed_border_gate: "ស្នើរសុំការផ្លាស់ប្តូរមាត់ច្រក",
        request_extended_date_of_entry: "ស្នើរសុំការពន្យាពេលថ្ងៃខែឆ្នាំចូល",
        request_extended_date_of_exit: "ស្នើរសុំការពន្យាពេលថ្ងៃខែឆ្នាំចេញ",
        reset_password: "កំណត់កូដសម្ងាត់របស់លោកអ្នកឡើងវិញ",
        resolve: "ដំណោះស្រាយ",
        restore: "រក្សាទុកវិញ",
        result: "លទ្ធផល",
        return_home: "ត្រឡប់ទៅទំព័រដើម",
        save: "រក្សាទុក",
        save_continue: "រក្សាទុក & បន្ទាប់",
        scan: "ស្គែន",
        search: "ស្វែងរក",
        search_application: "ស្វែងរកពាក្យស្នើសុំ",
        search_driver: "ស្វែងរកអ្នកបើកបរ",
        search_not_found: "មិនមានប្រតិវេទន៍ដែលលោកអ្នកកំពុងស្វែងរកនេាះទេ",
        search_vehicle: "ស្វែងរកយានយន្ត",
        security_returned: "ប្រាក់កក់នេះបានបង្វិលសងរួចហើយ",
        select: "ជ្រើសរើស",
        select_driver: "ជ្រើសរើសអ្នកបើកបរ",
        select_vehicle: "ជ្រើសរើសយានយន្ត",
        send: "ផ្ញើ",
        serial: "លេខសឺរៀល",
        setting: "ការកំណត់",
        setup_my_profile: "បំពេញព័ត៌មានរបស់ខ្ញុំ",
        sign_in: "ចូលប្រើ",
        size: "ទំហំ",
        status: "ស្ថានភាព",
        steer: "ចង្កូត",
        submit: "ដាក់ស្នើ",
        temporary_export: "ចេញបណ្តោះអាសន្ន",
        temporary_import: "ចូលបណ្តោះអាសន្ន",
        temporary_vehicle: "យានយន្តចេញចូលបណ្តោះអាសន្ន",
        terms_conditions: "លក្ខខណ្ឌផ្សេងៗ",
        timeline: "បន្ទាត់ពេលវេលា",
        to: "ទៅ",
        to_date: "ដល់",
        today_entry: "យានយន្តចូលថ្ងៃនេះ",
        today_exit: "យានយន្តចេញថ្ងៃនេះ",
        total_declaration: "ប្រតិវេទន៍សរុប",
        total_vehicle: "យានយន្តសរុប",
        type: "ប្រភេទ",
        update: "បច្ចុប្បន្នភាព",
        update_profile: "កែគណនី",
        updated_at: "កាលបរិច្ឆេទកែ",
        valid_from: "សុពលភាពចាប់ពី",
        valid_to: "សុពលភាពដល់",
        value_1: "តម្លៃ#១",
        value_2: "តម្លៃ#២",
        vehicle: "យានយន្ត",
        vehicle_and_driver: "យានយន្ត និង អ្នកបើកបរ",
        vehicle_chart: "ស្ថិតិយានយន្ត",
        vehicle_identitation_back: "ប័ណ្ណសម្គាល់យានយន្តផ្នែកខាងក្រោយ",
        vehicle_identitation_front: "ប័ណ្ណសម្គាល់យានយន្តផ្នែកខាងមុខ",
        vehicle_identity_photo: "រូបប័ណ្ណសម្គាល់យានយន្ត",
        vehicle_information: "ព័ត៌មានយានយន្ត/ មធ្យោបាយដឹកជញ្ជូ",
        vehicle_report: "របាយការណ៍យានយន្ត",
        vehicle_type: "ប្រភេទយានយន្ត",
        vehicles: "យានយន្ត",
        view: "មើល",
        view_attachment: "មើលឯកសារ",
        view_detail: "មើលលម្អិត",
        view_document: "មើលឯកសារ",
        view_image: "មើលរូបភាព",
        year: "ឆ្នាំផលិត",
        yes: "បាទ/ចាស",
        your_email: "សារអេឡិកត្រូនិករបស់អ្នក",
        your_information: "ព័ត៌មានទូទៅរបស់អ្នក",
        your_password: "កូដសម្ងាត់របស់អ្នក",
        zip: "កូដតំបន់",
        pending: "កំពុងរងចាំ",
        edit_detail: "កែប្រែលម្អិត",
        owners: "ម្ចាស់កម្មសិទិ្ធ",
        search_owner: "ស្វែងរកម្ចាស់កម្មសិទ្ធិ",
        choose_owner: "ជ្រើសរើសម្ចាស់កម្មសិទ្ធិ",
        select_owner: "ជ្រើសរើសម្ចាស់កម្មសិទ្ធិ",
        declined: "មិនឯកភាព",
        destination_approved: 'ការិយាល័យចុងទីអនុម័ត',
        telegram: "តេលេក្រាម",
        subscribe: "ភ្ជាប់",
        unsubscribe: "ផ្តាច់",
    },
    message: {
        already_declaration: "បានស្នើរសុំរួចហើយ!",
        approve_amendment: "តើអ្នកពិតជាចង់អនុញ្ញាតការផ្លាស់ប្តូរនេះមែនទេ?",
        choose_print_type: "សូមជ្រើសរើសប្រភេទបោះពុម្ព",
        click_to_view: "ចុចដើម្បីមើលឯកសារ",
        decline_amendment: "តើអ្នកពិតជាចង់បដិសេដការផ្លាស់ប្តូរនេះមែនទេ?",
        instruction_info: "សូមចុចលើប៊ូតុង យល់ព្រម ដើម្បីឱ្យប្រព័ន្ធនាំអ្នកទៅបំពេញបែបបទ។",
        no_driver: "លោកអ្នកនៅមិនទាន់មានព័ត៌មានអ្នកបើកបរនៅឡើយ!",
        no_result: "គ្មានទិន្នន័យ",
        no_vehicle: "លោកអ្នកនៅមិនទាន់មានព័ត៌មានយានយន្តនៅឡើយ!",
        not_update_passport: "លោកអ្នកមិនទាន់បំពេញព័ត៌មានលិខិតឆ្លងដែននៅឡើយ!",
        not_update_profile: "លោកអ្នកមិនទាន់បានកែ ព័ត៌មានផ្ទាល់ខ្លួន នៅឡើយ!",
        profile_completion_message: "គណនីរបស់លោកអ្នកមិនទាន់មានព័ត៌មានគ្រប់គ្រាន់សម្រាប់ស្នើសុំនៅឡើយ។ សូមបំពេញព័ត៌មានរបស់លោកអ្នកអោយបានគ្រប់គ្រាន់!",
        profile_completion_title: "សូមយកចិត្តទុកដាក់!",
        profile_success: "ព័ត៌មានផ្ទាល់ខ្លួនត្រូវបានរក្សាទុក",
        required_if_no_identity_card: "ព័ត៌មាននេះនឹងតម្រូវឱ្យបំពេញ ប្រសិនបើគ្មានអត្តសញ្ញាប័ណ្ណ",
        required_if_no_passport: "ព័ត៌មាននេះនឹងតម្រូវឱ្យបំពេញ ប្រសិនបើគ្មានលិខិតឆ្លងដែន",
        success: "ឯកសារត្រូវបានរក្សាទុកដោយជោគជ័យ",
        verify_phone: "យើងនឹងផ្ទៀងផ្ទាត់គណនីរបស់អ្នកតាមលេខទូរស័ព្ទនេះ សូមប្រាកដថាវាត្រឹមត្រូវ",
        please_complete_declaration_owner_first: "សូមបំពេញព័ត៌មានម្ចាស់កម្មសិទ្ធិអោយបានគ្រប់គ្រាន់!",
        owner_success: "ព័ត៌មានម្ចាស់កម្មសិទ្ធិត្រូវបានរក្សាទុក",
        driver_success: "ព័ត៌មានអ្នកបើកបរត្រូវបានរក្សាទុក",
        vehicle_success: "ព័ត៌មានយានយន្តត្រូវបានរក្សាទុក",
        are_you_sure: "តើលោកអ្នកប្រាកដទេ?",
    },
    validation: {
        attributes: {
            address: "ឤសយដ្ឋាននៅកម្ពុជា",
            address_in_cambodia: "ឤសយដ្ឋាននៅកម្ពុជា",
            attachment: "ឯកសារភ្ជាប់",
            border_pass_date: "កាលបរិច្ឆេទប័ណ្ណព្រំដែន",
            border_pass_number: "លេខប័ណ្ណព្រំដែន",
            owner_border_pass_number: "លេខប័ណ្ណព្រំដែន",
            brand: "ម៉ាក",
            color: "ពណ៌",
            company_code_v1: "កូដក្រុមហ៊ុន",
            destination_entry_date: "កាលបរិច្ឆេទចូល",
            destination_entry_office_name: "ឈ្មោះការិយាល័យចូល",
            destination_exit_date: "កាលបរិច្ឆេទចេញ",
            destination_exit_office_name: "ឈ្មោះការិយាល័យចេញ",
            destination_office_code_v1: "កូដការិយាល័យចុងទី",
            destination_office_date_v1: "កាលបរិច្ឆេទចុងទី",
            destination_office_date_v2: "កាលបរិច្ឆេទចុងទី",
            driver_address_in_cambodia: "ឤសយដ្ឋាននៅកម្ពុជា",
            driver_border_pass_date: "កាលបរិច្ឆេទប័ណ្ណព្រំដែន",
            driver_border_pass_number: "លេខប័ណ្ណព្រំដែន",
            driver_first_name: "នាមខ្លួន",
            driver_gender: "ភេទ",
            driver_identity_card_number: "លេខអត្តសញ្ញាណប័ណ្ណ",
            driver_identity_card_issued_date: "កាលបរិច្ឆេទអត្តសញ្ញាណប័ណ្ណ",
            driver_identity_card_expired_date: "សុពលភាពអត្តសញ្ញាណប័ណ្ណ",
            driver_last_name: "គោត្តនាម",
            driver_nationality: "សញ្ជាតិ",
            driver_passport_expired_date: "សុពលភាពលិខិតឆ្លងដែន",
            driver_passport_issued_date: "កាលបរិច្ឆេទលិខិតឆ្លងដែន",
            driver_passport_number: "លេខលិខិតឆ្លងដែន",
            driving_license_image_back: "រូបខាងក្រោយ",
            driving_license_image_front: "រូបខាងមុខ",
            engine_number: "លេខម៉ាស៊ីន",
            entry_date: "កាលបរិច្ឆេទចូល",
            entry_office_name: "ឈ្មោះការិយាល័យចូល",
            exit_date: "កាលបរិច្ឆេទចេញ",
            exit_office_name: "ឈ្មោះការិយាល័យចេញ",
            first_name: "នាមខ្លួន",
            frame_number: "លេខតួ",
            fraud_code: "លេខកូដ",
            fraud_name: "ឈ្មោះ",
            fraud_valid_from: "សុពលភាពចាប់ពី",
            fraud_valid_to: "សុពលភាពដល់",
            from_date: "ចាប់ពី",
            full_name: "គោត្តនាម នាម",
            fullname: "គោត្តនាម នាម",
            fullname_v1: "គោត្តនាម នាម",
            gender: "ភេទ",
            gender_v1: "ភេទ",
            identity_date: "កាលបរិច្ឆេទអត្តសញ្ញាណប័ណ្ណ",
            identity_date_expire: "សុពលភាពលិខិតឆ្លងដែន",
            identity_image_back: "រូបខាងក្រោយ",
            identity_image_front: "រូបខាងមុខ",
            identity_number: "លេខអត្តសញ្ញាណប័ណ្ណ",
            identity_v1: "អត្តសញ្ញាណប័ណ្ណ",
            insurance_company_code: "កូដក្រុមហ៊ុនធានារ៉ាប់រង",
            insurance_company_name: "មោះក្រុមហ៊ុនធានារ៉ាប់រង",
            insurance_date: "កាលបរិច្ឆេទធានារ៉ាប់រង",
            insurance_number: "លេខធានារ៉ាប់រង",
            last_name: "នាមត្រកូល",
            lodgement_office_code_v1: "កូដការិយាល័យដើមទី",
            lodgement_office_date_v1: "កាលបរិច្ឆេទដើមទី",
            lodgement_office_date_v2: "កាលបរិច្ឆេទដើមទី",
            nationality: "សញ្ជាតិ",
            nationality_v1: "សញ្ជាតិ",
            office_code: "កូដការិយាល័យ",
            other: "ឯកសារផ្សេងទៀត",
            owner_border_pass_date: "កាលបរិច្ឆេទប័ណ្ណព្រំដែន",
            owner_border_pass_v1: "ប័ណ្ណព្រំដែនម្ចាស់កម្មសិទ្ធ",
            owner_passport_number: "លេខលិខិតឆ្លងដែន",
            owner_passport_v1: "លិខិតឆ្លងដែន",
            passport_expired_date: "សុពលភាពលិខិតឆ្លងដែន",
            passport_image_back: "រូបខាងក្រោយ",
            passport_image_front: "រូបខាងមុខ",
            passport_issued_date: "កាលបរិច្ឆេទលិខិតឆ្លងដែន",
            passport_number: "លេខលិខិតឆ្លងដែន",
            passport_v1: "លិខិតឆ្លងដែន",
            plate_number: "ផ្លាកលេខ",
            profile_address: "ឤសយដ្ឋាននៅកម្ពុជា",
            profile_driving_license_image_back: "រូបប័ណ្ណបើកបរផ្នែកខាងក្រោយ",
            profile_driving_license_image_front: "រូបប័ណ្ណបើកបរផ្នែកខាងមុខ",
            profile_first_name: "នាមខ្លួន",
            profile_gender: "ភេទ",
            profile_identity_date: "កាលបរិច្ឆេទអត្តសញ្ញាណប័ណ្ណ",
            profile_identity_date_expire: "សុពលភាពអត្តសញ្ញាណប័ណ្ណ",
            profile_identity_image_back: "រូបខាងក្រោយ",
            profile_identity_image_front: "រូបខាងមុខ",
            profile_identity_number: "លេខអត្តសញ្ញាណប័ណ្ណ",
            profile_last_name: "នាមត្រកូល",
            profile_nationality: "សញ្ជាតិ",
            profile_passport_image_back: "រូបខាងក្រោយ",
            profile_passport_image_front: "រូបខាងមុខ",
            register_type: "ប្រភេទស្នើសុំ",
            registration_date_v1: "កាលបរិច្ឆេទចុះបញ្ជី",
            registration_date_v2: "កាលបរិច្ឆេទចុះបញ្ជី",
            registration_number: "លេខចុះបញ្ជី",
            registration_number_v1: "លេខចុះបញ្ជី",
            registration_number_v2: "លេខចុះបញ្ជី",
            registration_type: "ប្រភេទ",
            registration_type_v1: "ប្រភេទ",
            registration_year_v1: "ឆ្នាំចុះបញ្ជី",
            registration_year_v2: "ឆ្នាំចុះបញ្ជី",
            request_change_description: "បរិយាយនៃស្នើរសុំការផ្លាស់ប្តូរ",
            request_change_description2: "បរិយាយនៃស្នើរសុំការផ្លាស់ប្តូរ",
            security_date: "កាលបរិច្ឆេទ",
            security_number: "លេខបង្កាន់ដៃ",
            security_office: "ការិយាល័យ",
            security_serial: "លេខសឺរៀល",
            steer: "ចង្កូត",
            to_date: "រហូតដល់",
            type: "ប្រភេទ",
            vehicle_type: "ប្រភេទ",
            verify_amend_description: "បរិយាយ",
            year: "នាំផលិត"
        }
    }
}